import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ClientMetric, OrderMetric } from '../constants/metrics/cancelled-orders.metric';

class AnalyticCancelledOrdersService extends EntityApiService<any> {
  getOrderMetric = (metric: OrderMetric, params?: any, config?: RequestConfig) => {
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/cancelled-orders/${metric}`), params, config),
    );
  };

  getClientMetric = (metric: ClientMetric, params?: any, config?: RequestConfig) => {
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/cancelled-orders/clients/${metric}`), params, config),
    );
  };
}

export const analyticCancelledOrdersService = new AnalyticCancelledOrdersService('/ms-analytics/api/v1');
export default analyticCancelledOrdersService;
